module.exports = __webpack_public_path__ + "static/img/yuqi-bg1.e9cd5cb9.png";